<div class="dtf-olp" style="background-color: #E6E6E6;">
    <div class="container_dashboard">
        <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">

            <div class="example-button-row">
                <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState"
                    (change)="onChangeButton($event)">
                    <mat-button-toggle [value]="toggleEnum.Option7"
                        [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option1"
                        [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option3"
                        [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option6"
                        [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option4"
                        [class.selected]="selectedState === toggleEnum.Option4" style="background-color: #00566A !important; color: white !important;">Manage
                        Bank Profile</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option2"
                        [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
                    <mat-button-toggle [value]="toggleEnum.Option8"
                        [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
                </mat-button-toggle-group>
            </div>



            <div *ngIf="blocked">
                <dtf-errorhandling [blocked]="blocked" [errorMessage]="errmsg"></dtf-errorhandling>
            </div>
            <div *ngIf="step1">

                <div class="dtf-sub-dashboard container_dashboard">
                   

                    <div *ngIf="status === 'loading'" class="mbfs-payoff-quote-spinner"
                        style="margin-bottom: 20px;">
                        <!--Spinner on Login Load-->
                        <div class="demo-container">
                            <span>{{ 'Invoice.Loading' | translate }}</span>
                            <div class="progress-bar">
                                <div class="progress-bar-value"></div>
                            </div>
                        </div>
                        <br>
                    </div>

                    <div class="card">
                        <h1>Edit Bank Profile</h1>
                        <div class="row">
                            <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                                <div class="pageStyle paragrapSpace">

                                    To edit your on-line profile,
                                    <b><i>only edit the fields that require a change. </i></b> The remaining information
                                    will
                                    remain unchanged and will not be updated. Some information will not be displayed
                                    fully for
                                    security reasons.
                                </div>
                                <div class="pageStyle paragrapSpace body_required" *ngIf="invalid">
                                    {{CORRECTINFORMATION}}
                                </div>
                                <div class="pageStyle paragrapSpace body_required" *ngIf="invalid">
                                    <ul>
                                        <li style="margin-left:30px;" *ngIf="inValidBankRoutingNum">
                                            {{INVALIDROUTINGNUM}}</li>
                                        <li style="margin-left:30px;" *ngIf="invalidEmailAddress">{{EMAILVALIDATION}}
                                        </li>
                                        <li style="margin-left:30px;" *ngIf="invalidConfirmEmail">
                                            {{CONFIRMEMAILVALIDATION}}
                                        </li>
                                        <li style="margin-left:30px;" *ngIf="invalidAccountNumber">
                                            {{INVALIDACCOUNTNUMBER}}</li>
                                        <li style="margin-left:30px;" *ngIf="consecutiveNum">
                                            {{INVALIDACCOUNTNUMBERPATTERN}}
                                        </li>
                                        <li class="body_required" *ngIf="errormsg">Invalid Bank Account and Routing Number Combination. Please verify your information and try again, or contact your bank for assistance.</li>
                                        <li class="body_required" *ngIf="showNameOnAcctError">Invalid entry, Special characters are not permitted, and at least one alphabetic character is required.</li>
                                    </ul>
                                </div>

                                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                                    <div class="Add_image paragrapSpace">
                                        <div class="row form-group">
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 title">Bank Routing Number
                                            </div>
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                <input type="text" class="inputText" style="width:150px;" maxlength="9"
                                                    formControlName="routingNum" (change)="getBankName()"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                                                <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif"
                                                    alt="" style="margin-left:5px;" *ngIf="inValidBankRoutingNum">
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                (Current: xxxxx{{routingNum | slice:-4}})
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 title">Bank Account Type
                                            </div>
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                <input type="radio" name="acctType" value='S'
                                                    formControlName="acctType" />
                                                Saving
                                                <input type="radio" name="acctType" value="C"
                                                    formControlName="acctType" />
                                                Checking
                                                <br>
                                                <input type="radio" name="acctType" value="CC"
                                                    formControlName="acctType" />
                                                Corporate Checking
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                (Current: {{accDescription}})
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 title">Bank Name</div>
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                <input type="text" class="inputText" style="width:150px;"
                                                    readonly formControlName="bankName" />
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-4 col-xs-6 lightcon">
                                                (Current: {{bankName}})
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 title">Bank Account Number
                                            </div>
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 lightcon" style="display: flex;">
                                                <input type="password" #password1 class="inputText" style="width:150px;" size="30"
                                                    maxlength="17" formControlName='acctNum'
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57" /> &nbsp;&nbsp;                
                                                <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, hide)">
                                                    <span class="input-group-text"><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                                                </div>
                                                <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif"
                                                    alt="" style="margin-left:5px;"
                                                    *ngIf="invalidAccountNumber || consecutiveNum">
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                (Current: xxxxxxxxx{{acctNum | slice:-4}})
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 title">Name On Bank Account
                                            </div>
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                <input type="text" class="inputText" style="width:150px;" size="30"
                                                    formControlName='nameOnBankAcct' />
                                                <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" alt="" style="margin-left:5px;"
                                                 *ngIf="showNameOnAcctError">
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-4 col-xs-6 lightcon">
                                                (Current: {{nameOnBankAcct}})
                                                <br>
                                                Note: You must be an Authorized Signer and User for the Bank Account
                                                listed. Special characters are not allowed. This field is for display purposes only and does not alter your legal name on record.
                                            </div>

                                        </div>
                                        <div class="row form-group">
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 title">Email Address</div>
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                <input type="text" class="inputText" style="width:150px;" size="30"
                                                    formControlName='email' />
                                                <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif"
                                                    alt="" style="margin-left:5px;" *ngIf="form.controls.email.invalid && submitted || invalidEmailAddress">

                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-4 col-xs-6 lightcon">
                                                (Current: {{email}})
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 title">Confirm Email Address
                                            </div>
                                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 lightcon">
                                                <input type="text" class="inputText" style="width:150px;" size="30"
                                                    onpaste="return false;" formControlName='emailConfirm' />
                                                <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif"
                                                    alt="" style="margin-left:5px;" *ngIf="form.controls.emailConfirm.invalid && submitted || invalidConfirmEmail">
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-4 col-xs-6 lightcon">
                                                (Current: {{emailConfirm}})
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display:flex;flex-direction: row;gap:10px" class="mt-4">
                                       
                                        <div><input type="submit" value="Continue >"
                                                class="mbfs-button" />
                                        </div>
                                        <div><input type="button" value="Cancel >" class="mbfs-button"
                                                routerLink="/home/bankprofile" /> </div>
                                        <div *ngIf="status === 'loading'">Please wait. We are validating your information
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div *ngIf="beforestep2">
                <div class="card">
                    <h1>Edit Bank Profile Verification</h1>
                    <br>
                    <p>Please review the information below before submitting your updated payment profile information.
                        Be aware
                        that editing your profile will only affect payments made after this date. If you have a payment
                        pending,
                        your old profile will still be used.</p>
                    <br>
                    <div class="row" style="margin-top: 5px;">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                            Bank Name
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                            {{this.updateBankProfile.bankName}}
                        </div>
                    </div>
                    <div class="row" style="margin-top: 5px;">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                            Bank Account Type
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                            {{this.updateBankProfile.acctDescription}}
                        </div>
                    </div>
                    <div class="row" style="margin-top: 5px;">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                            Bank Account Number
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                            xxxxxxxxx{{this.updateBankProfile.acctNum | slice:-4}}
                        </div>
                    </div>
                    <div class="row" style="margin-top: 5px;">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                            Bank Routing Number
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                            xxxxx{{this.updateBankProfile.routingNum | slice:-4}}
                        </div>
                    </div>
                    <div class="row" style="margin-top: 5px;">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                            Email Address
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                            {{this.updateBankProfile.email}}
                        </div>
                    </div>
                </div>
                <br>
                <div style="display:flex;flex-direction: row;gap:10px" class="mt-4">
                <!-- <button class="mbfs-button" (click)="back()">Back</button> -->
                  <div *ngIf="agentview ==='true'">
                    <button class="mbfs-button" disabled>Continue</button>
                  </div>
                  <div *ngIf="agentview !='true'">
                    <button class="mbfs-button" (click)="onSubmitVerification()">Continue</button>
                  </div>
                
                <button class="mbfs-button" (click)="Cancel()">Cancel</button>
                <div *ngIf="status === 'updating'">Please wait. We are updating your information</div>
                </div>
            </div>

            <div *ngIf="continue">
                
                    <div class="card">
                        <h1>Edit Bank Profile Conirmation</h1>
                        <br>
                        <p>Thank you for using the Online Payment Service. Your profile has been updated.</p>
                        <br>
                        <div class="row" style="margin-top: 5px;">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                                Bank Name
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                {{this.bName}}
                            </div>
                        </div>
                        <div class="row" style="margin-top: 5px;">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                                Bank Account Type
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                {{this.atype}}
                            </div>
                        </div>
                        <div class="row" style="margin-top: 5px;">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                                Bank Account Number
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                {{this.aNum}}
                            </div>
                        </div>
                        <div class="row" style="margin-top: 5px;">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                                Bank Routing Number
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                {{this.rNumber }}
                            </div>
                        </div>
                        <div class="row" style="margin-top: 5px;">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                                Email Address
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                {{this.Eemail}}
                            </div>
                        </div>
                    </div>
                    <br>
                    <!-- <button class="mbfs-button" (click)="back()">Back</button> -->
                    <button class="mbfs-button" (click)="downloadPDF()">Print</button>
                    <button class="mbfs-button" (click)="Done()">Done</button>
                
            </div>
        </div>
    </div>
</div>